export default "__VITE_ASSET__BusXquVn__"